export default __webpack_public_path__ + "a83b218.png";